import { inject } from "vue";
export function useConfig() {
    const config = inject("config");
    if (!config) {
        throw Error("Config not provided. Diy you forget app.provide('config', config)?");
    }
    return config;
}
